import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Menu, MenuItem } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { sa, PillButton } from '../superAdminUi';

// The account-status filter, built on the same styled-dropdown pattern as the per-user
// Actions menu (a pill trigger + MUI Menu) so it matches the rest of the surface, rather
// than a native <select> that opens the OS-default list.
function StatusFilterMenu({ value, options, onChange }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const current = options.find((o) => o.value === value);

  const choose = (next) => {
    setAnchorEl(null);
    if (next !== value) onChange(next);
  };

  return (
    <>
      <PillButton
        type='button'
        $variant='outline'
        onClick={(event) => setAnchorEl(event.currentTarget)}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        aria-label='Filter users by account status'
        data-testid='user-status-filter'
      >
        {current ? current.label : 'Status'}
        <ArrowDropDownIcon fontSize='small' />
      </PillButton>
      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        {options.map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === value}
            onClick={() => choose(option.value)}
            sx={{
              fontFamily: sa.font.family,
              fontSize: '13px',
              '&.Mui-selected': { color: sa.color.teal, fontWeight: sa.font.semibold },
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

StatusFilterMenu.propTypes = {
  value: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({ value: PropTypes.string, label: PropTypes.string })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default StatusFilterMenu;
